import React, { Fragment } from 'react';
import { Alert, Label } from 'reactstrap';
import FormikInputField from '~/components/formikInputField/formikInputField';
import FormLayout from '~/components/formLayout/formLayout';
import SubmissionButton from '~/components/submissionButton/submissionButton';

/**
 * Don't allow the user to set something as in use. However, if the status is already `IN_USE`
 * then we need that option in the dropdown to be shown as the currently selected value. In this
 * case the select is disabled so the user can't change it from that anyway
 */
const statusOptions = status => {
  const options = [
    <option key="E" value="EMPTY">
      Empty
    </option>,
    <option key="R" value="REQUIRES_CLEANING">
      Requires cleaning
    </option>,
    <option key="U" value="UNAVAILABLE">
      Unavailable
    </option>
  ];
  if (status === 'IN_USE') {
    options.push(
      <option key="I" value="IN_USE">
        In use
      </option>
    );
  }
  return options;
};

const TankForm = ({ errors, touched, handleSubmit, isSubmitting, buttonText, values: { id, status } }) => {
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <FormLayout title="Tank overview">
        <div className="mb3">
          <Label>Name</Label>
          <FormikInputField name="name" invalid={!!errors.name} />
          {errors.name && (
            <p data-qa="name-error" className="error">
              {errors.name}
            </p>
          )}
        </div>
        <div className="mb3">
          <Label>Tank type</Label>
          <FormikInputField type="select" name="type" invalid={!!errors.type}>
            <option value="BREW_KEG">Brew keg</option>
            <option value="BREW_TANK">Brew tank</option>
            <option value="BRITE_TANK">Brite tank</option>
            <option value="UNI_TANK">Uni tank</option>
          </FormikInputField>
          {errors.type &&
            touched.type && (
              <p data-qa="type-error" className="error">
                {errors.type}
              </p>
            )}
        </div>
        {id && (
          <Fragment>
            <div className="mb3">
              <Label>Status</Label>
              <FormikInputField type="select" name="status" invalid={!!errors.status}>
                {statusOptions(status)}
              </FormikInputField>
              {errors.status &&
                touched.status && (
                  <p data-qa="status-error" className="error">
                    {errors.status}
                  </p>
                )}
            </div>
          </Fragment>
        )}
        <div className="mb3">
          <Label>Volume</Label>
          <FormikInputField name="volume" type="number" invalid={!!errors.volume} />
          {errors.volume && (
            <p data-qa="volume-error" className="error">
              {errors.volume}
            </p>
          )}
        </div>
      </FormLayout>
      <FormLayout className="mt4" title="Notes">
        <div className="mb3">
          <Label>Notes</Label>
          <FormikInputField type="textarea" name="notes" />
        </div>
      </FormLayout>
      <div className="flex justify-end mt4">
        <SubmissionButton color="primary" type="submit" isSubmitting={isSubmitting}>
          Save
        </SubmissionButton>
      </div>
    </form>
  );
};

export default TankForm;



// WEBPACK FOOTER //
// ./src/components/tankForm/tankForm.jsx